<template>
  <div class="config-list">
    <div class="config-list-desktop">
      <div class="config-tabs">
        <div
          class="config-tab"
          @click="setCurrentTab(1)"
          :class="{ 'tab-selected': currentConfig == 1 }"
        >
          <div class="config-tab-label">
            <span class="material-symbols-rounded">settings</span>Configurar
            taxa
          </div>
          <i
            class="fa fa-angle-right"
            style="margin-right: 24px; color: #5d758d"
          ></i>
        </div>
        <div
          v-if="showEasyPayment"
          class="config-tab"
          @click="setCurrentTab(2)"
          :class="{ 'tab-selected': currentConfig == 2 }"
        >
          <div class="config-tab-label">
            <span class="material-symbols-rounded">attach_money</span>Pagamento
            dos presentes
          </div>
          <div class="config-alert-label">
            <span v-if="!hasClickedGiftsPayment" class="material-symbols-rounded icon-pulse">info</span>
            <i
            class="fa fa-angle-right"
            style="margin-right: 24px; color: #5d758d"
            ></i>
          </div>
        </div>
        <div
          class="config-tab"
          @click="setCurrentTab(3)"
          :class="{ 'tab-selected': currentConfig == 3 }"
          v-if="showPostalcardConfig"
        >
          <div class="config-tab-label">
            <base-icon width="24" height="24" name="postcard" class="mr-1" />
            Cartões postais
          </div>
            <i
            class="fa fa-angle-right"
            style="margin-right: 24px; color: #5d758d"
          ></i>
        </div>
        <div
          class="config-tab"
          @click="setCurrentTab(4)"
          :class="{ 'tab-selected': currentConfig == 4 }"
        >
          <div class="config-tab-label">
            <span class="material-symbols-rounded">visibility</span>
            Visibilidade da lista
          </div>
          <i
            class="fa fa-angle-right"
            style="margin-right: 24px; color: #5d758d"
          ></i>
        </div>
        <div
          class="config-tab"
          @click="setCurrentTab(5)"
          :class="{ 'tab-selected': currentConfig == 5 }"
        >
          <div class="config-tab-label">
            <i class="fa fa-arrow-down-a-z"></i>Exibição dos presentes
          </div>
            <i
            class="fa fa-angle-right"
            style="margin-right: 24px; color: #5d758d"
            ></i>
        </div>
      </div>
      <div class="config-content">
        <div v-if="currentConfig == 1">
          <div class="tab-one-numbers columns" v-if="!shouldShowNewTaxsInterface && !shouldShowFlexibleFeesInterface">
            <div class="column is-one-third tab-one-labels">
              <div class="numbers-title">Taxa da lista</div>
              <div>
                <span class="numbers-value"
                  >{{ taxTransactionFormatted }}% </span
                ><span v-if="isTaxPromotional" class="numbers-title"
                  >(valor promocional)</span
                >
              </div>
            </div>
            <div class="right-bordered"></div>
            <div class="column is-one-third tab-one-labels">
              <div class="numbers-title">Custo por saque</div>
              <div class="numbers-value">R$ 0,00</div>
            </div>
            <div class="right-bordered"></div>
            <div class="column is-one-third tab-one-labels">
              <div class="numbers-title">Quantidade de saques</div>
              <div class="numbers-value">Ilimitado</div>
            </div>
          </div>
          <WarningRulesBanner
            v-if="shouldShowWarningBanner" 
            text="Novas regras de recebimento em vigor a partir de 18/12/2025: 8 dias úteis para cartão e 2 dias úteis para Pix ou boleto."
            padding="16px 24px"
            style="margin: 24px 0 -24px 0;" 
            type="warning"
            />
          <div class="tab-one-taxs" v-if="shouldShowNewTaxsInterface">
            <h3>Taxa dos seus presentes e o tempo de recebimento:</h3>
            <div class="tab-one-cards-section">
              <UserTaxCard iconName="painel/pix-icon-btn" title="Pix e Boleto" :tax="taxTransactionFormatted" days="2" />
              <UserTaxCard iconName="painel/credit-card-icon" title="Cartão de Crédito" :tax="taxTransactionFormatted" days="8" />
            </div>
            <WarningRulesBanner 
              text="A taxa é única para todos os métodos de pagamento. O que varia é apenas o prazo de recebimento conforme o método escolhido pelo convidado."
              padding="16px 24px"
              style="margin: 0px;"
              type="info"
              />
          </div>
          <FlexibleFeesInterface 
            v-if="shouldShowFlexibleFeesInterface" 
            :creditCardFees="flexibleFees" 
            :creditCardFeeSelected="flexibleFeesSelected" 
            :pixFee="taxTransactionFormatted" 
            pixRepassDeadline="2" 
            @select-fee="configFlexibleFee"
            />
          <div class="tab-one-subtitle">
            Defina quem irá assumir a taxa dos presentes:
          </div>
          <div class="tab-one-card-options">
            <div class="tab-one-card-content" style="width: inherit">
              <b-field>
                <b-radio
                  v-model="checkboxTax"
                  @change.native="configTaxes('B')"
                  native-value="B"
                ></b-radio>
              </b-field>
              <div style="text-align: left">
                <div class="tab-one-card-content-label font-color-neutral">
                  Repassar a taxa dos presentes para os convidados
                </div>
                <div class="tab-one-card-content-sublabel">
                  A taxa será embutida no valor dos seus presentes e o convidado
                  verá apenas o valor total.
                </div>
              </div>
            </div>
            <div class="recommended">recomendado</div>
          </div>
          <div class="tab-one-card-options">
            <div class="tab-one-card-content">
              <b-field>
                <b-radio
                  v-model="checkboxTax"
                  @change.native="configTaxes('A')"
                  native-value="A"
                ></b-radio>
              </b-field>
              <div style="text-align: left">
                <div class="tab-one-card-content-label font-color-neutral">
                  Queremos assumir a taxa dos presentes
                </div>
                <div class="tab-one-card-content-sublabel">
                  Vocês receberão o valor do presente na Carteira já com o
                  desconto da taxa.
                </div>
              </div>
            </div>
          </div>
          <div class="tab-one-footer">
            Caso vocês alterem esta configuração, ela será aplicada apenas para
            os novos presentes recebidos.
          </div>
        </div>
        <div v-if="currentConfig == 2" class="main-tab-content" data-testid="gift-payment_main">
          <p class="tab-two-label">
            Defina abaixo como deverá ser aplicada a taxa de pagamento dos seus
            presentes. Em ambos os casos,
            <span> a taxa será paga pelos convidados.</span>
          </p>
          <div>
            <div class="tab-one-card-options">
              <div class="tab-one-card-content">
                <b-field>
                  <b-radio
                  class="w-radio-5"
                  data-testid="gift-payment_conventional-option"
                  v-model="checkboxPayment"
                  @change.native="configPayment('juros')"
                  native-value="juros"
                  ></b-radio>
                </b-field>
                <div style="text-align: left">
                  <div class="tab-one-card-content-label font-color-bold-neutral">
                    Pagamento convencional
                  </div>
                  <div class="tab-one-card-content-sublabel font-color-neutral">
                    Seus convidados podem parcelar em até 6x com juros de 2,99% por parcela.
                  </div>
                </div>
              </div>
            </div>
            <div 
            :class="['tab-one-card-options-with-tag', { 'border-pulse': checkboxPayment !== 'embutida' }]"
            data-testid="gift-payment_custom-card-border" 
            >
              <div 
              data-testid="gift-payment_custom-card-tag"
              class="custom-recommended">
                Maior economia no parcelamento
              </div>
              <div class="tab-one-card-content" style="width: inherit">
                <b-field  class="mt-1">
                  <b-radio
                  class="w-radio-5"
                  data-testid="gift-payment_easy-option"
                  v-model="checkboxPayment"
                  @change.native="configPayment('embutida')"
                  native-value="embutida"
                  ></b-radio>
                </b-field>
                <div style="text-align: left">
                <div class="tab-one-card-content-label font-color-bold-neutral">
                  Pagamento facilitado
                </div>
                <div class="tab-one-card-content-sublabel font-color-neutral">
                  Seus convidados podem parcelar em até <strong>6x com taxa única</strong> já aplicada no valor do presente.  
                  <p class="my-3 tab-two-alert font-color-neutral">
                    Acréscimo <strong>único</strong> de 5,99% no valor total do presente (aplicável a todas as formas de pagamento: PIX, boleto e cartão de crédito à vista).
                  </p>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="center-installment-simulator">
            <easy-installment-simulator :tax="taxTransaction" >
            </easy-installment-simulator>
          </div>
          <div class="tab-one-footer">
            <span>  
              Caso vocês alterem esta configuração, ela será aplicada apenas para
              os novos presentes recebidos.
            </span>
          </div>
        </div>
        <div v-if="currentConfig == 3 && showPostalcardConfig" class="main-tab-content gap-2">
          <p class="tab-two-label">
            Seus convidados poderão enviar um cartão postal físico com mensagens de felicitações junto aos presentes.
          </p>

          <h5 class="tab-three-title">Escolha uma das opções para receber seus cartões postais: </h5>
          <div>
            <div 
            class="tab-one-card-options"                
            :class="{ 'tab-three-selected-border': postalcardEmbedded }"
            @click="setEmbeddedPostalcard(true)"
            >
              <div 
              data-testid="gift-payment_custom-card-tag"
              class="recommended">
                Mais escolhido
              </div>
              <div class="tab-one-card-content">
                <b-field>
                  <b-radio
                  class="w-radio-5"
                  data-testid="gift-payment_conventional-option"
                  v-model="postalcardEmbedded"
                  :native-value="true"
                  ></b-radio>
                </b-field>
                <div style="text-align: left">
                  <div class="tab-one-card-content-label font-color-bold-neutral">
                    Cartões inclusos na compra
                  </div>
                  <div class="tab-one-card-content-sublabel font-color-neutral">
                    Nessa opção, os convidados verão o valor dos presentes <strong>com o cartão incluso,</strong> mas poderão removê-lo no momento da compra.                  
                  </div>
                </div>
              </div>
            </div>
            <div 
            class="tab-one-card-options mb-0"
            :class="{ 'tab-three-selected-border': !postalcardEmbedded }"
            @click="setEmbeddedPostalcard(false)"
            >
              <div class="tab-one-card-content" style="width: inherit">
                <b-field  class="mt-1">
                  <b-radio
                  class="w-radio-5"
                  data-testid="gift-payment_easy-option"
                  v-model="postalcardEmbedded"
                  :native-value="false"
                  ></b-radio>
                </b-field>
                <div style="text-align: left">
                <div class="tab-one-card-content-label font-color-bold-neutral">
                  Cartões opcionais na compra
                </div>
                <div class="tab-one-card-content-sublabel font-color-neutral">
                  Nessa opção, os convidados verão o valor dos presentes <strong>sem o cartão incluso.</strong>  
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="tab-three-footer mb-0">
            <span>  
              Caso vocês alterem esta configuração, ela será aplicada apenas para
              os novos presentes recebidos.
            </span>
          </div>
          <div class="tab-three-snackbar-container">
            <div>
              <span class="material-symbols-rounded tab-three-info-icon">info</span>
            </div>
            <div class="tab-three-snackbar-title">
              <p>
                <strong>Importante:</strong> Se um convidado comprar mais de um presente:
              </p>
              <div>
                <span>•</span>
                <p>Vocês receberão <strong>apenas um cartão postal.</strong></p>
              </div>
              <div>
                <span>•</span>
                <p>O valor dos cartões extras será descontado automaticamente no final da compra.</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="currentConfig == 4">
          <div class="tab-two-published-list">
            <span style="color: #5d758d; font-weight: 700"
              >Lista publicada: &nbsp;
            </span>
            <div style="color: #e583a2; font-weight: 700">
              {{ published ? ' Sim' : ' Não' }}
            </div>
            <b-switch
              @input="$refs.convincingDeactivatingList.open(published)"
              class="switch-csr"
              v-model="published"
              style="margin-left: 10px"
            ></b-switch>
          </div>
          <b-notification
            v-if="published"
            type="is-success is-light"
            role="alert"
            class="mt-4"
            :closable="false"
          >
            <strong>
              Seus presentes estão visíveis e disponíveis para compra no seu
              site.
            </strong>
          </b-notification>
          <b-notification
            v-else
            type="is-warning is-light"
            role="alert"
            class="mt-4"
            :closable="false"
          >
            <strong>
              Os presentes não estão exibidos no site para os convidados. Para
              exibí-los, publique a sua lista.
            </strong>
          </b-notification>
        </div>
        <div v-if="currentConfig == 5">
          <section>
            <div class="tab-four-label">
              Como vocês querem que os seus convidados vejam os presentes?
            </div>
            <div class="tab-four-items">
              <b-radio
                v-model="checkboxOrder"
                size="is-small"
                native-value="valor_final_com_taxa_asc"
                @change.native="editGiftListOrder('valor_final_com_taxa_asc')"
              ></b-radio>
              <div style="text-align: left">
                <div class="tab-four-sublabel">
                  Do menor para o maior valor (valor crescente)
                </div>
              </div>
            </div>
            <div class="tab-four-items">
              <b-radio
                v-model="checkboxOrder"
                size="is-small"
                native-value="valor_final_com_taxa_desc"
                @change.native="editGiftListOrder('valor_final_com_taxa_desc')"
              ></b-radio>
              <div style="text-align: left">
                <div class="tab-four-sublabel">
                  Do maior para o menor valor (valor decrescente)
                </div>
              </div>
            </div>
            <div class="tab-four-items">
              <b-radio
                v-model="checkboxOrder"
                size="is-small"
                native-value="nome_asc"
                @change.native="editGiftListOrder('nome_asc')"
              ></b-radio>
              <div style="text-align: left">
                <div class="tab-four-sublabel">Ordem alfabética (A-Z)</div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- --------------------------------------------------------------->
    <div class="config-list-mobile">
      <section>
        <b-collapse
          class="card card-config"
          animation="slide"
          aria-id="contentIdForA11y1"
          :open="currentConfig == 1"
          @open="currentConfig = 1"
        >
          <template #trigger="props">
            <div
              class=""
              role="button"
              aria-controls="contentIdForA11y1"
              :aria-expanded="props.open"
            >
              <div
                class="config-tab tab-mobile"
                :class="{ 'tab-selected': currentConfig == 1 }"
              >
                <div class="config-tab-label">
                  <span class="material-symbols-rounded">settings</span
                  >Configurar taxa
                </div>
                <a class="card-header-icon">
                  <img :src="props.open ? menuUp : menuDown" />
                </a>
              </div>
            </div>
          </template>

          <div class="card-content content-mobile">
            <div>
              <div v-if="!shouldShowNewTaxsInterface && !shouldShowFlexibleFeesInterface" class="tab-one-numbers-mobile">
                <div>
                  <div class="numbers-title">Taxa da lista</div>
                  <div style="margin-bottom: 16px">
                    <span class="numbers-value">
                      {{ taxTransactionFormatted }}%
                    </span>
                    <span v-if="isTaxPromotional" class="numbers-title"
                      >(valor promocional)</span
                    >
                  </div>
                </div>
                <hr class="mobile-separator" />
                <div>
                  <div class="numbers-title">Custo por saque</div>
                  <div style="margin-bottom: 16px" class="numbers-value">
                    R$ 0,00
                  </div>
                </div>
                <hr class="mobile-separator" />
                <div>
                  <div class="numbers-title">Quantidade de saques</div>
                  <div class="numbers-value">Ilimitado</div>
                </div>
              </div>
              <WarningRulesBanner
                v-if="shouldShowWarningBanner" 
                text="Novas regras de recebimento em vigor a partir de 18/12/2025: 8 dias úteis para cartão e 2 dias úteis para Pix ou boleto."
                padding="16px 24px"
                style="margin: 24px 0 -24px 0;"  
                type="warning"
                />
              <div v-if="shouldShowNewTaxsInterface" class="tab-one-taxs">
                <h3>Taxa dos seus presentes e o tempo de recebimento:</h3>
                <div class="tab-one-cards-section">
                  <UserTaxCard iconName="painel/pix-icon-btn" title="Pix e Boleto" :tax="taxTransactionFormatted" days="2" />
                  <UserTaxCard iconName="painel/credit-card-icon" title="Cartão de Crédito" :tax="taxTransactionFormatted" days="8" />
                </div>            
                <WarningRulesBanner 
                text="A taxa é única para todos os métodos de pagamento. O que varia é apenas o prazo de recebimento conforme o método escolhido pelo convidado."
                padding="16px 24px"
                style="margin: 0;"
                type="info"
                />
              </div>
              <FlexibleFeesInterface 
                v-if="shouldShowFlexibleFeesInterface" 
                :creditCardFees="flexibleFees" 
                :creditCardFeeSelected="flexibleFeesSelected" 
                :pixFee="taxTransactionFormatted" 
                pixRepassDeadline="2" 
                @select-fee="configFlexibleFee"
                />
              <div class="tab-one-subtitle">
                Defina quem irá assumir a taxa dos presentes:
              </div>

              <div
                class="tab-one-card-options card-options-mobile"
                style="display: block"
              >
                <div class="recommended-mobile">recomendado</div>
                <div class="tab-one-card-content pt-0">
                  <!-- <b-checkbox v-model="checkboxCustom"></b-checkbox> -->
                  <b-radio
                    size="is-small"
                    v-model="checkboxTax"
                    @change.native="configTaxes('B')"
                    native-value="B"
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-one-card-content-label font-color-neutral">
                      Repassar a taxa dos presentes para os convidados
                    </div>
                    <div class="tab-one-card-content-sublabel">
                      A taxa será embutida no valor dos seus presentes e o
                      convidado verá apenas o valor total.
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-one-card-options card-options-mobile">
                <div class="tab-one-card-content">
                  <!-- <b-checkbox v-model="checkboxCustom"></b-checkbox> -->
                  <b-radio
                    size="is-small"
                    v-model="checkboxTax"
                    @change.native="configTaxes('A')"
                    native-value="A"
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-one-card-content-label font-color-neutral">
                      Queremos assumir a taxa dos presentes
                    </div>
                    <div class="tab-one-card-content-sublabel">
                      Vocês receberão o valor do presente na Carteira já com o
                      desconto da taxa.
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-one-footer"
                style="font-size: 16px; color: #5d758d; text-align: justify"
              >
                Caso vocês alterem esta configuração, ela será aplicada apenas
                para os novos presentes recebidos.
              </div>
            </div>
          </div>
        </b-collapse>

        <b-collapse
          v-if="showEasyPayment"
          class="card card-config"
          animation="slide"
          aria-id="contentIdForA11y1"
          :open="currentConfig == 2"
          @open="currentConfig = 2"
        >
          <template #trigger="props">
            <div
              class=""
              role="button"
              aria-controls="contentIdForA11y1"
              :aria-expanded="props.open"
            >
              <div
                class="config-tab tab-mobile"
                :class="{ 'tab-selected': currentConfig == 2 }"
              >
                <div class="config-tab-label">
                  <span class="material-symbols-rounded">attach_money</span>
                  Pagamento dos presentes
                </div>
                <div class="config-alert-label">
                  <span v-if="!hasClickedGiftsPayment" class="material-symbols-rounded icon-pulse">info</span>
                  <a class="custom-alert-menu">
                    <img :src="props.open ? menuUp : menuDown" />
                  </a>
                </div>
              </div>
            </div>
          </template>

          <div class="card-content content-mobile">
            <div class="main-tab-content" data-testid="gift-payment-mobile_main">
              <p class="tab-two-label">
                Defina abaixo como deverá ser aplicada a taxa de pagamento dos
                seus presentes. Em ambos os casos, 
                <span>a taxa será paga pelos convidados.</span>
              </p>
              <div>
              <div class="tab-one-card-options card-options-mobile">
                <div class="tab-one-card-content">
                  <!-- <b-checkbox v-model="checkboxCustom"></b-checkbox> -->
                  <b-radio
                  class="w-radio-5"
                    size="is-small"
                    data-testid="gift-payment-mobile_conventional-option"
                    v-model="checkboxPayment"
                    @change.native="configPayment('juros')"
                    native-value="juros"
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-one-card-content-label font-color-bold-neutral">
                      Pagamento convencional
                    </div>
                    <div class="tab-one-card-content-sublabel font-color-neutral">
                      Seus convidados podem parcelar em até 6x com juros de 2,99% por parcela.
                    </div>
                  </div>
                </div>
              </div>
              <div
                :class="['tab-one-card-options-with-tag card-options-mobile', { 'border-pulse': checkboxPayment !== 'embutida' }]"
                style="display: block"
                data-testid="gift-payment-mobile_custom-card-border" 
              >
                <div
                data-testid="gift-payment-mobile_custom-card-tag" 
                class="custom-recommended-mobile">
                  Maior economia no parcelamento
                </div>
                <div class="tab-one-card-content flex-col pt-0" style="width: inherit">
                  <div class="tab-one-card-main-content">
                    <b-field class="mt-1">
                      <b-radio
                      class="w-radio-5"
                      data-testid="gift-payment-mobile_easy-option"
                      v-model="checkboxPayment"
                      @change.native="configPayment('embutida')"
                      native-value="embutida"
                      ></b-radio>
                    </b-field>
                    <div style="text-align: left">
                      <div class="tab-one-card-content-label font-color-bold-neutral">
                        Pagamento facilitado
                      </div>
                      <div class="tab-one-card-content-sublabel font-color-neutral">
                        Seus convidados podem parcelar em até <strong>6x com taxa única</strong> já aplicada no valor do presente.
                      </div>
                    </div>
                  </div>
                  <p class="tab-two-alert mt-16 font-color-neutral">
                    Acréscimo <strong>único</strong> de 5,99% no valor total do presente (aplicável a todas as formas de pagamento: PIX, boleto e cartão de crédito à vista).
                  </p>
                  </div>
                </div>
              </div>
              <div class="center-installment-simulator">
                <easy-installment-simulator :tax="taxTransaction">
                </easy-installment-simulator>
              </div>
              <div
                class="tab-one-footer"
                style="font-size: 16px; color: #5d758d; text-align: justify"
              >
                Caso vocês alterem esta configuração, ela será aplicada apenas
                para os novos presentes recebidos.
              </div>
            </div>
          </div>
        </b-collapse>

        <b-collapse
          class="card card-config"
          animation="slide"
          aria-id="contentIdForA11y1"
          :open="currentConfig == 3"
          @open="currentConfig = 3"
          v-if="showPostalcardConfig"
        >
          <template #trigger="props">
            <div
              role="button"
              aria-controls="contentIdForA11y1"
              :aria-expanded="props.open"
            >
              <div
                class="config-tab tab-mobile"
                :class="{ 'tab-selected': currentConfig == 3}"
                v-if="showPostalcardConfig"
              >
                <div class="config-tab-label">
                  <base-icon width="24" height="24" name="postcard" class="mr-1" />
                  Cartões postais
                </div>
                <a class="card-header-icon">
                  <img :src="props.open ? menuUp : menuDown" />
                </a>
              </div>
            </div>
          </template>

          <div class="card-content content-mobile">
            <div class="main-tab-content gap-2">
              <p class="tab-two-label">
                Seus convidados poderão enviar um cartão postal físico com mensagens de felicitações junto aos presentes.
              </p>

              <h5 class="tab-three-title">Escolha uma das opções para receber seus cartões postais:</h5>
              <div>
              <div 
              class="tab-one-card-options card-options-mobile"
              style="display: block"
              :class="{ 'tab-three-selected-border': postalcardEmbedded }"
              @click="setEmbeddedPostalcard(true)"
              >
                <div
                data-testid="gift-payment-mobile_custom-card-tag" 
                class="recommended-mobile">
                  Mais escolhido
                </div>
                <div class="tab-one-card-content pt-0">
                  <b-radio
                  class="w-radio-5"
                    size="is-small"
                    data-testid="gift-payment-mobile_conventional-option"
                    v-model="postalcardEmbedded"
                    :native-value="true"
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-one-card-content-label font-color-bold-neutral">
                      Cartões inclusos na compra
                    </div>
                    <div class="tab-one-card-content-sublabel font-color-neutral">
                     Nessa opção, os convidados verão o valor dos presentes <strong>com o cartão incluso,</strong> mas poderão removê-lo no momento da compra. 
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-one-card-options card-options-mobile"
                style="display: block"
                data-testid="gift-payment-mobile_custom-card-border"
                :class="{ 'tab-three-selected-border': !postalcardEmbedded }"
                @click="setEmbeddedPostalcard(false)"
              >

                <div class="tab-one-card-content flex-col mb-0" style="width: inherit">
                  <div class="tab-one-card-main-content">
                    <b-field class="mt-1">
                      <b-radio
                      class="w-radio-5"
                      data-testid="gift-payment-mobile_easy-option"
                      v-model="postalcardEmbedded"
                      :native-value="false"
                      ></b-radio>
                    </b-field>
                    <div style="text-align: left">
                      <div class="tab-one-card-content-label font-color-bold-neutral">
                        Cartões opcionais na compra
                      </div>
                      <div class="tab-one-card-content-sublabel font-color-neutral">
                        Nessa opção, os convidados verão o valor dos presentes <strong>sem o cartão incluso.</strong>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-three-footer mb-0"
              >
                Caso vocês alterem esta configuração, ela será aplicada apenas
                para os novos presentes recebidos.
              </div>
              <div class="tab-three-snackbar-container">
                <div>
                  <span class="material-symbols-rounded tab-three-info-icon">info</span>
                </div>
                <div class="tab-three-snackbar-title">
                  <p>
                    <strong>Importante:</strong> Se um convidado comprar mais de um presente:
                  </p>
                  <div>
                    <span>•</span>
                    <p>Vocês receberão <strong>apenas um cartão postal.</strong></p>
                  </div>
                  <div>
                    <span>•</span>
                    <p>O valor dos cartões extras será descontado automaticamente no final da compra.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>

        <b-collapse
          class="card card-config"
          animation="slide"
          aria-id="contentIdForA11y2"
          :open="currentConfig == 4"
          @open="currentConfig = 4"
        >
          <template #trigger="props">
            <div
              class=""
              role="button"
              aria-controls="contentIdForA11y2"
              :aria-expanded="props.open"
            >
              <div
                class="config-tab tab-mobile"
                :class="{ 'tab-selected': currentConfig == 4 }"
              >
                <div class="config-tab-label">
                  <span class="material-symbols-rounded">visibility</span>
                  Visibilidade da lista
                </div>
                <a class="card-header-icon">
                  <img :src="props.open ? menuUp : menuDown" />
                </a>
              </div>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              <div class="tab-two-published-list published-list-mobile">
                <span style="color: #5d758d; font-weight: 700"
                  >Lista publicada: &nbsp;
                </span>
                <div style="color: #e583a2; font-weight: 700">
                  {{ published ? ' Sim' : ' Não' }}
                </div>
                <b-switch
                  class="switch-csr"
                  @input="$refs.convincingDeactivatingList.open(published)"
                  v-model="published"
                  style="margin-left: 10px"
                ></b-switch>
              </div>
              <b-notification
                v-if="published"
                type="is-success is-light"
                role="alert"
                class="mt-3"
                :closable="false"
              >
                <strong>
                  Seus presentes estão visíveis e disponíveis para compra no seu
                  site.
                </strong>
              </b-notification>
              <b-notification
                v-else
                type="is-warning is-light"
                role="alert"
                class="mt-3"
                :closable="false"
              >
                <strong>
                  Os presentes não estão exibidos no site para os convidados.
                  Para exibí-los, publique a sua lista.
                </strong>
              </b-notification>
            </div>
          </div>
        </b-collapse>

        <b-collapse
          class="card card-config"
          animation="slide"
          aria-id="contentIdForA11y3"
          :open="currentConfig == 5"
          @open="currentConfig = 5"
        >
          <template #trigger="props">
            <div
              class=""
              role="button"
              aria-controls="contentIdForA11y3"
              :aria-expanded="props.open"
            >
              <div
                class="config-tab tab-mobile"
                :class="{ 'tab-selected': currentConfig == 5 }"
              >
                <div class="config-tab-label">
                  <i class="fa fa-arrow-down-a-z"></i>Exibição dos presentes
                </div>
                <a class="card-header-icon">
                  <img :src="props.open ? menuUp : menuDown" />
                </a>
              </div>
            </div>
          </template>

          <div class="card-content">
            <div class="card-text-style">
              <section>
                <div class="tab-four-label label-mobile">
                  Como vocês querem que os seus convidados vejam os presentes?
                </div>
                <div class="tab-four-items">
                  <b-radio
                    v-model="checkboxOrder"
                    size="is-small"
                    native-value="valor_final_com_taxa_asc"
                    @change.native="
                      editGiftListOrder('valor_final_com_taxa_asc')
                    "
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-four-sublabel">
                      Do menor para o maior valor (valor crescente)
                    </div>
                  </div>
                </div>
                <div class="tab-four-items">
                  <b-radio
                    v-model="checkboxOrder"
                    size="is-small"
                    native-value="valor_final_com_taxa_desc"
                    @change.native="
                      editGiftListOrder('valor_final_com_taxa_desc')
                    "
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-four-sublabel">
                      Do maior para o menor valor (valor decrescente)
                    </div>
                  </div>
                </div>
                <div class="tab-four-items">
                  <b-radio
                    v-model="checkboxOrder"
                    size="is-small"
                    native-value="nome_asc"
                    @change.native="editGiftListOrder('nome_asc')"
                  ></b-radio>
                  <div style="text-align: left">
                    <div class="tab-four-sublabel">Ordem alfabética (A-Z)</div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </b-collapse>
      </section>
    </div>
    <ModalConvincingDeactivatingList
      @confirmed="editGiftListVisibility"
      @keep="() => (published = true)"
      ref="convincingDeactivatingList"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ModalConvincingDeactivatingList from './ModalConvincingDeactivatingList/ModalConvincingDeactivatingList.vue'
import UserTaxCard from './UserTaxCard.vue'
import menuUp from '@/assets/img/chevron-up.svg'
import menuDown from '@/assets/img/chevron-down.svg'
import GiftsApi from '@/lib/api/Gifts'
import Account from '@/lib/api/Account'  

import { EasyInstallmentSimulator } from 'casar-web-components'
import WarningRulesBanner from '@/components/Shared/WarningRulesBanner.vue'
import FlexibleFeesInterface from './FlexibeFees/FlexibleFeesInterface.vue'


const GIFT_LIST_TAX_DEFAULT = 3.89

export default {
  components: {
    ModalConvincingDeactivatingList,
    UserTaxCard,
    WarningRulesBanner,
    FlexibleFeesInterface
  },

  data() {
    return {
      menuUp,
      menuDown,
      currentConfig: 1,
      checkboxOrder: 'nome_asc',
      checkboxTax: 'B',
      checkboxPayment: 'juros',
      checkBenefits: false,
      showEasyPayment: false,
      published: true,
      taxTransaction: null,
      hasClickedGiftsPayment: false,
      showPostalcardConfig: false,
      postalcardEmbedded: true,
      shouldShowFlexibleFeesInterface: false,
      flexibleFeesSelected: '',
      flexibleFees: []
    }
  },

  mounted() {
    this.getTaxes()
    this.getGiftListConfig()
    this.setShowPostalcardConfig()
    this.changeTabByQuery()
    this.checkGiftsPaymentClicked()
    this.checkNewRepassInterface()
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken',
      wedSiteInfo: 'app/getWedSiteInfo',
      newRepassTimeEnabled: 'app/getNewRepassTimeEnabled'
    }),

    taxTransactionFormatted() {
      const tax = this.taxTransaction || GIFT_LIST_TAX_DEFAULT
      return tax.toString().replace('.', ',')
    },

    isTaxPromotional() {
      return this.taxTransaction < GIFT_LIST_TAX_DEFAULT
    },

    shouldShowWarningBanner(){
      // Comunicação desativada no mmomento, porém retornará em breve
      return false
    },

    shouldShowNewTaxsInterface() {
      if(this.shouldShowFlexibleFeesInterface) return false

      return this.newRepassTimeEnabled
    },
  },

  methods: {
    ...mapActions({
      setSaving: 'gifts/setSaving',
      notification: 'app/setNotification',
    }),

    changeTabByQuery() {
      if (this.$route.query.tab) {
        switch (this.$route.query.tab) {
          case 'configurar-taxa':
            this.setCurrentTab(1)
            break
          case 'pagamento-dos-presentes':
            this.setCurrentTab(2)
            break
          case 'cartoes-postais':
            this.setCurrentTab(3)
            break
          case 'visibilidade-da-lista':
            this.setCurrentTab(4)
            break
          case 'exibicao-dos-presentes':
            this.setCurrentTab(5)
            break
        }
      }
    },

    checkGiftsPaymentClicked(){
      this.hasClickedGiftsPayment = localStorage.getItem('hasClickedGiftsPayment') === 'true';
    },

    setHasClickedGiftsPayment(){
      if(!this.hasClickedGiftsPayment) {
        localStorage.setItem('hasClickedGiftsPayment', 'true');
        this.hasClickedGiftsPayment = true;
      }
    },

    setCurrentTab(tab) {
      this.currentConfig = tab
      if (tab === 2) this.setHasClickedGiftsPayment()
    },

    getTaxes() {
      const giftsApi = new GiftsApi(this.logonToken)

      giftsApi
        .getTaxes()
        .then((response) => {
          if (!response.data) throw 'Error on get taxes'
          this.showEasyPayment =
            response.data.virtual_rate_configs_type == 'parcelamento'
          this.checkboxPayment =
            response.data.virtual_rate_installment_type || 'juros'
          this.taxTransaction = response.data.virtual_rate_transaction_custom
          this.checkboxTax = response.data.virtual_rate_option || 'B'

          if(response.data.group && response.data.group?.taxes?.length === 3){
            this.shouldShowFlexibleFeesInterface = true;
            this.flexibleFeesSelected = response.data.virtual_rate_transaction_card ?? '';
            this.flexibleFees = response.data.group.taxes;
          }
        })
        .catch((error) => console.error(error))
    },

    getGiftListConfig() {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi.getGiftListConfig().then((response) => {
        if (!response.data) throw 'Without "data" on save gift list config'
        this.published = response.data.published
        this.checkboxOrder = response.data.order || 'nome_asc'
      })
    },

    configFlexibleFee(optionId){
      this.flexibleFeesSelected = optionId

      let data = {
        virtual_rate_transaction_card: optionId
      }
      this.editTaxes(data)
    },

    configTaxes(value) {
      this.checkboxTax = value
      let data = {
        virtual_rate_option: this.checkboxTax,
      }
      this.editTaxes(data)
    },

    configPayment(value) {
      let data = {
        virtual_rate_option: this.checkboxTax,
        virtual_rate_installment_type: value,
      }
      this.editTaxes(data)
    },

    editTaxes(data) {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi
        .editTaxes(data)
        .then((response) => {
          if (!response.data) throw 'Without "data" on edit gift list taxes'
          this.setSaving(true)
        })
        .catch(() => {
          return this.notification({
            message: 'Erro ao editar taxa. Por favor, tente novamente.',
            show: true,
            class: 'is-error',
          })
        })
    },

    editGiftListOrder(value) {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi.editGiftListOrder(value).then((response) => {
        if (!response.data) throw 'Without "data" on edit gift list order'
        this.setSaving(true)
      })
    },

    editGiftListVisibility() {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi.editGiftListVisibility(this.published).then((response) => {
        if (!response.data) throw 'Without "data" on edit gift list visibility'
        this.setSaving(true)
      })
    },

    setEmbeddedPostalcard(value){
      if(value === this.postalcardEmbedded) return

      const repository = new GiftsApi(this.logonToken)
      repository.savePostalcardsConfig(value);
      
      this.postalcardEmbedded = value;
    },
    
    setShowPostalcardConfig(){
      const repository = new GiftsApi(this.logonToken);
      repository.getGiftsConfigs().then((response) => {
        const { visualizar_embutir_cards, embutir_cards } = response.data;
        const getListVersion = this.$store.state.app.wedSiteInfo.shared_menu.gifts_edition_version;
        
        this.showPostalcardConfig = getListVersion == 'gifts-list-v2' && visualizar_embutir_cards == "1";
        this.postalcardEmbedded = embutir_cards == 1 ? true : false;  
      });
    },

    async checkNewRepassInterface() {
      if (this.newRepassTimeEnabled === null) {
        try {
          const repository = new Account(this.logonToken);
          const response = await repository.getNewRepassTimeEnabled(this.wedId);
          this.newRepassTimeEnabled === response.data?.data?.enable_time_repass === true;
        } catch (error) {
          this.newRepassTimeEnabled === false;
          console.error(error)
        }
      }
    }
  },


}
</script>
<style lang="scss" scoped>
.config-list-mobile {
  display: none;
  @media (max-width: 930px) {
    display: block;
  }
}

.tab-mobile {
  background-color: #fff !important;
  justify-content: space-between;
  width: 100% !important;
}

.tab-one-numbers-mobile {
  background-color: $neutrallightest;
  padding-top: 24px;
  padding-bottom: 24px;
  border-radius: 16px;
  text-align: center;
}

.published-list-mobile {
  margin-top: 0px !important;
  width: auto !important;
  margin-left: 0px !important;
}

.tab-two-alert {
  padding: 8px 20px;
  background-color: rgba($supportlight, 20%);
  border-radius: 8px;
}

.label-mobile {
  margin-top: -20px !important;
  margin-left: 16px !important;
  margin-bottom: 16px !important;
}

.tab-four-items {
  margin-left: 16px !important;
  margin-bottom: 8px !important;
}

.custom-recommended-mobile {
  background: #3DAFB0;
  border-radius: 4px;
  height: auto;
  color: #fff;
  margin-right: 4px;
  margin-top: 4px;
  margin-bottom: 12px;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  padding: 4px 8px;
}

.center-installment-simulator {
  display: flex;
  align-items: center;
  justify-content: center;
}

.recommended-mobile {
  background: $primary;
  border-radius: 8px;
  width: 114px;
  height: 33px;
  color: #fff;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  margin-bottom: 12px;
}
.card-config {
  margin-bottom: 24px;
  border-radius: 16px;
}

.custom-alert-menu{
  display: flex;
  align-items: center;
  padding: .75rem 1rem .75rem 0;
}

.config-alert-label {
  display: flex;
  align-items: center;
  gap: 6px;

  @media (max-width: 929px) {
    gap: 2px;
  }
}

.icon-pulse {
  position: relative;
  display: inline-block;
  z-index: 1;
  color: $primary;
}

.icon-pulse::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #F4CBD8;
  z-index: -1;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  70% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.tab-one-card-main-content {
  display: flex;
  flex-direction: row;
}

.flex-col {
	flex-direction: column;
}

.config-list-desktop {
  display: flex;
  @media (max-width: 930px) {
    display: none;
  }
}

.content-mobile {
  padding-top: 0px;
}

.mobile-separator {
  display: inline-flex;
  width: 32px;
  border: 1px solid rgba(180, 197, 214, 0.5);
  margin-bottom: 16px;
}
.config-tab-label {
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-size: 16px;

  span,
  i {
    margin-right: 8px;
    color: $neutral;
  }

  i {
    font-size: 18px;
  }
}
.config-list {
  margin-top: 48px;
  margin-bottom: 60px;
}

.config-content {
  border: 1px solid rgba(180, 197, 214, 0.5);
  border-radius: 16px;
  min-height: 264px !important;
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
  height: fit-content;
}

.config-tabs {
  margin-right: 16px;
  color: $neutral;
}
.config-tab {
  background: #fff;
  border: 1px solid #dde7f1;
  border-radius: 16px;
  width: 320px;
  height: 72px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: $neutral;
  justify-content: space-between;

  @media (min-width: 600px) and (min-width: 800px) {
    font-size: 14px;
  }
}

.tab-selected {
  background: $neutrallightest;
  font-weight: 700;

  svg,
  path,
  span,
  i {
    color: $primary;
  }
}

.custom-recommended{
  background: #3DAFB0;
  top: 4px;
  right: 4px;
  border-radius: 8px;
  height: 33px;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  left: auto;
  bottom: auto;
  position: absolute;
  align-items: center;
  padding: 8px;
}

.recommended {
  background: $primary;
  top: 0;
  right: 0;
  border-radius: 8px;
  height: 33px;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  left: auto;
  bottom: auto;
  position: absolute;
  align-items: center;
  padding: 8px;
}

.tab-one-labels {
  display: grid;
  margin-top: 48px;
  text-align: center;
}

.right-bordered {
  border-right: 1px solid $neutrallight;
  height: 32px;
  margin-top: 70px;
  vertical-align: middle;
}
.numbers-title {
  color: $neutral;
  font-size: 16px;
  font-weight: 400;
}
.numbers-value {
  color: $primary;
  font-size: 18px;
  font-weight: 700;
}

.tab-one-taxs {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  margin-top: 24px;
  margin-bottom: -24px;
  
  h3 {
    color: #374455;
    font-size: 16px;
    font-weight: 700;
  }
  
  @media (max-width: 930px) {
    margin-top: 0px;
    gap: 16px;
  }
}

.tab-one-cards-section {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
  
  @media (max-width: 930px) {
    flex-direction: column;
    gap: 16px;
  }
}

.tab-one-subtitle {
  color: $neutral;
  margin-top: 48px;
  text-align: left;
  margin-bottom: 24px;
  font-weight: 700;
  font-size: 16px;
}

.tab-one-card-options-with-tag {
  background: #ffffff;
  border-radius: 8px;
  width: 100%;
  height: auto;
  min-height: 92px;
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid $primary;
}

.border-pulse {
  animation: border-pulse 1.5s infinite;
}

@keyframes border-pulse {
  0% {
    border: 1px solid $primary;
  }
  50% {
    border: 1px solid  #F4CBD8;
  }
  75% {
    border: 1px solid  #F4CBD8;
  }
  100% {
    border: 1px solid $primary;
  }
}

.mt-16 {
  margin-top: 16px;
}

.tab-one-card-options {
  background: #ffffff;
  border: 1px solid rgba(180, 197, 214, 0.5);
  border-radius: 8px;
  width: 100%;
  height: auto;
  min-height: 92px;
  position: relative;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}

.tab-one-card-content {
  display: inline-flex;
  align-items: start;
  padding-top: 16px;
  padding: 24px;

  @media (min-width: 769px) and (max-width: 936px) {
    padding: 28px 24px;
  }

  @media (max-width: 768px) {
    .pt-0 {
      padding-top: 0;
    }

    padding: 24px 16px;
  }

  .tab-one-card-content-label {
    font-weight: 700;
    font-size: 16px;
  }

  .tab-one-card-content-sublabel {
    font-weight: 400;
  }

  .font-color-bold-neutral {
    color: #4E637B;
  }

  .font-color-neutral {
    color: $neutral;

    strong {
      color: $neutral;
    }
  }
}
.tab-one-footer {
  text-align: left;
  margin-bottom: 24px;
}

.tab-two-published-list {
  background: #ffffff;
  border: 1px solid #dde7f1;
  border-radius: 8px;
  width: 280px;
  height: 56px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  margin-top: 32px;
}

.main-tab-content {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.tab-two-label {
  color: $neutral;
  margin-top: 24px;
  font-size: 16px;
  text-align: left;
  
  span {
    font-weight: 700;
  }

  @media (max-width: 936px) {
    font-size: 14px;
  }
}

.button-action {
  height: 40px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  color: $support;
  border: 0;
  cursor: pointer;
  background-color: transparent;
  &:hover,
  &:focus {
    border: 0;
    color: $supportdark;
  }
  .icon {
    margin-bottom: -8px;
    width: 15px;
  }
}

.tab-three-title {
  color: #4E637B;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
}

.tab-three-snackbar-container {
  padding: 8px;
  width: 100%;
  border-radius: 8px;
  background-color: #F6F7F9;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-start;
  align-items: stretch;
  margin-bottom: 24px;
}

.tab-three-snackbar-title {
  font-size: 14px;
  line-height: 20px;
  color: $neutral;
  
  strong {
    color: $neutral;
  }

  div {
    display: flex;
    flex-direction: row;
  }

  span {
    margin: 0px 3px;
  }

  @media (max-width: 930px) {
    font-size: 12px;
    line-height: 16px;
  }
}

.tab-three-selected-border {
  border: 1px solid $primary;
}

.tab-three-footer {
  text-align: left;
  margin-bottom: 24px;
  color: $neutral;
  font-size: 16px;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
}

.mb-0 {
  margin-bottom: 0px;
}

.mr-1 {
  margin-right: 8px !important;
}

.tab-three-info-icon {
  font-size: 20px;
  color: $neutral;
}

.gap-2 {
  gap: 16px;
}

.tab-four-label {
  color: $neutral;
  margin-top: 32px;
  margin-left: 17px;
  font-weight: 700;
  text-align: left;
  margin-bottom: 24px;
}

.tab-four-sublabel {
  font-weight: 400;
}

.tab-four-items {
  display: flex;
  align-items: center;
  font-weight: 400;
  margin-left: 24px;
  margin-bottom: 40px;
}
</style>
